<template>
    <b-overlay :show="loading || pdfLoading">
        <div class="worker-id-document p-4">
            <div class="form-section-header d-flex justify-content-between align-items-center mb-4 p-3 rounded"
                style="background-color: #eaf6ff">
                <div class="text-center flex-grow-1">
                    <!-- Updated by Jarir 2026-03-30 : Added Bangladesh Gazette header -->
                    <p class="mb-0 font-weight-bold" style="color: #333; font-size: 0.85rem;">Bangladesh Gazette -
                        বাংলাদেশ গেজেট</p>
                    <h6 class="mb-0 font-weight-bold" style="color: #007bff">
                        Form No: 07
                    </h6>
                    <small class="text-muted" style="font-size: 0.75rem">Under Section 7, Rule 7(1) and (2) <br />
                        First Part (A) <br />
                    </small>
                    <h6 class="mb-0 font-weight-bold">Worker Identification Document</h6>
                    <p class="mb-0 small bn-text">শ্রমিকের সনাক্তকরনের তথ্য</p>
                </div>
                <div class="d-flex" v-if="$acl && $acl['admin-service-book/worker-identification'] == 2">
                    <b-button variant="primary" size="sm" class="d-flex align-items-center mr-2" @click="saveData"
                        :disabled="loading || !isEditMode">
                        <b-icon icon="check-circle" class="mr-1"></b-icon> Save Changes
                    </b-button>
                    <!-- alpha fix- chnaged style hare  -->
                    <b-button :variant="isEditMode ? 'danger' : 'primary'" size="sm" class="d-flex align-items-center"
                        style="
                            font-size: 15px;
                            font-weight: 600 !important;
                            line-height: 18.688px;
                            border-radius: 8px;
                            padding: 10px 15px;
                        " @click="isEditMode = !isEditMode">
                        <b-icon :icon="isEditMode ? 'x-circle' : 'pencil-square'" class="mr-1"></b-icon>

                        {{ isEditMode ? "Disable Edit Mode" : "Enable Edit Mode" }}
                    </b-button>
                </div>
            </div>

            <div class="card shadow-sm">
                <div class="card-body p-4">
                    <div class="row">
                        <!-- Left and Middle Fields -->
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <!-- Updated by Jarir 2026-03-30 — EN always readonly (from Employee), BN editable -->
                                    <label class="label-custom">Worker's Name :</label>
                                    <b-form-input v-model="form.worker_name.en" class="form-control-custom"
                                        readonly></b-form-input>
                                    <label class="label-custom mt-1">শ্রমিকের নাম :</label>
                                    <!-- Updated 2026-07-30 — per-field max length via vee-validate. Typing is not truncated:
                       once past the limit the field turns red with the message and saveData blocks the save. -->
                                    <b-form-input v-model="form.worker_name.bn" name="worker_name_bn"
                                        v-validate="'max:40'" data-vv-as="শ্রমিকের নাম" class="form-control-custom"
                                        :readonly="!isEditMode"
                                        :state="fieldErrors.worker_name_bn ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.worker_name_bn ? false : null">{{
                                        fieldErrors.worker_name_bn }}</b-form-invalid-feedback>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="label-custom">Father's Name *:</label>
                                    <b-form-input v-model="form.father_name.en" name="father_name_en"
                                        v-validate="'max:40'" data-vv-as="Father's Name (English)"
                                        class="form-control-custom" :readonly="!isEditMode"
                                        :state="fieldErrors.father_name_en ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.father_name_en ? false : null">{{
                                        fieldErrors.father_name_en }}</b-form-invalid-feedback>
                                    <label class="label-custom mt-1">পিতার নাম *:</label>
                                    <b-form-input v-model="form.father_name.bn" name="father_name_bn"
                                        v-validate="'max:40'" data-vv-as="পিতার নাম" class="form-control-custom"
                                        :readonly="!isEditMode"
                                        :state="fieldErrors.father_name_bn ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.father_name_bn ? false : null">{{
                                        fieldErrors.father_name_bn }}</b-form-invalid-feedback>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="label-custom">Mother's Name *:</label>
                                    <b-form-input v-model="form.mother_name.en" name="mother_name_en"
                                        v-validate="'max:40'" data-vv-as="Mother's Name (English)"
                                        class="form-control-custom" :readonly="!isEditMode"
                                        :state="fieldErrors.mother_name_en ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.mother_name_en ? false : null">{{
                                        fieldErrors.mother_name_en }}</b-form-invalid-feedback>
                                    <label class="label-custom mt-1">মাতার নাম *:</label>
                                    <b-form-input v-model="form.mother_name.bn" name="mother_name_bn"
                                        v-validate="'max:40'" data-vv-as="মাতার নাম" class="form-control-custom"
                                        :readonly="!isEditMode"
                                        :state="fieldErrors.mother_name_bn ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.mother_name_bn ? false : null">{{
                                        fieldErrors.mother_name_bn }}</b-form-invalid-feedback>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <!-- Updated by Jarir 2026-04-20 — EN autoflows from Employee Profile spouse dependent (readonly); BN editable -->
                                    <label class="label-custom">Spouse's Name (if applicable):</label>
                                    <b-form-input v-model="form.spouse_name.en" class="form-control-custom"
                                        readonly></b-form-input>
                                    <label class="label-custom mt-1">স্বামী/স্ত্রীর নাম (প্রযোজ্য ক্ষেত্রে):</label>
                                    <b-form-input v-model="form.spouse_name.bn" name="spouse_name_bn"
                                        v-validate="'max:40'" data-vv-as="স্বামী/স্ত্রীর নাম"
                                        class="form-control-custom" :readonly="!isEditMode"
                                        :state="fieldErrors.spouse_name_bn ? false : null"></b-form-input>
                                    <b-form-invalid-feedback :state="fieldErrors.spouse_name_bn ? false : null">{{
                                        fieldErrors.spouse_name_bn }}</b-form-invalid-feedback>
                                </div>
                            </div>

                            <div class="mt-4">
                                <h6 class="font-weight-bold" style="font-size: 0.9rem">
                                    Permanent Address স্থায়ী ঠিকানা:
                                </h6>
                                <hr class="mt-1 mb-3" />
                                <div class="row">
                                    <!-- Updated by Jarir 2026-03-30 16:29 : Side-by-Side EN/BN fields & Reordered (District > SubDistrict > Police Station > Post Office > Village/Area > Road) -->

                                    <!-- District -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">District *:</label>
                                        <b-form-select v-model="form.permanent_district.en" :options="districtOptions"
                                            class="form-control-custom" :disabled="!isEditMode"
                                            :state="isEditMode && submitAttempted && !form.permanent_district.en ? false : null"
                                            @change="onDistrictChange"></b-form-select>
                                        <b-form-invalid-feedback
                                            :state="isEditMode && submitAttempted && !form.permanent_district.en ? false : null">District
                                            (English) is required</b-form-invalid-feedback>
                                    </div>
                                    <!-- Updated by Jarir 2026-04-09 — BN district as dropdown sourced from bangladesh_locations_bn.json -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">জেলা *:</label>
                                        <b-form-select v-model="form.permanent_district.bn" :options="districtOptionsBn"
                                            class="form-control-custom" :disabled="!isEditMode"
                                            :state="isEditMode && submitAttempted && !form.permanent_district.bn ? false : null"></b-form-select>
                                        <b-form-invalid-feedback
                                            :state="isEditMode && submitAttempted && !form.permanent_district.bn ? false : null">District
                                            (Bangla) is required</b-form-invalid-feedback>
                                    </div>

                                    <!-- SubDistrict -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">SubDistrict *:</label>
                                        <b-form-select v-model="form.permanent_sub_district.en"
                                            :options="subdistrictOptions" class="form-control-custom"
                                            :disabled="!isEditMode || !form.permanent_district.en"
                                            :state="isEditMode && submitAttempted && !form.permanent_sub_district.en ? false : null"
                                            @change="onSubDistrictChange"></b-form-select>
                                        <b-form-invalid-feedback
                                            :state="isEditMode && submitAttempted && !form.permanent_sub_district.en ? false : null">Sub-District
                                            (English) is required</b-form-invalid-feedback>
                                    </div>
                                    <!-- Updated by Jarir 2026-04-09 — BN subdistrict as dropdown; gates on BN district independently of EN side -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">উপজেলা *:</label>
                                        <b-form-select v-model="form.permanent_sub_district.bn"
                                            :options="subdistrictOptionsBn" class="form-control-custom"
                                            :disabled="!isEditMode || !form.permanent_district.bn"
                                            :state="isEditMode && submitAttempted && !form.permanent_sub_district.bn ? false : null"></b-form-select>
                                        <b-form-invalid-feedback
                                            :state="isEditMode && submitAttempted && !form.permanent_sub_district.bn ? false : null">উপজেলা
                                            (Bangla) is required</b-form-invalid-feedback>
                                    </div>

                                    <!-- Police Station -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">Police Station *:</label>
                                        <b-form-input v-model="form.permanent_police_station.en"
                                            name="permanent_police_station_en" v-validate="'max:25'"
                                            data-vv-as="Police Station (English)" class="form-control-custom"
                                            :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_police_station_en ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_police_station_en ? false : null">{{
                                                fieldErrors.permanent_police_station_en }}</b-form-invalid-feedback>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">থানা *:</label>
                                        <b-form-input v-model="form.permanent_police_station.bn"
                                            name="permanent_police_station_bn" v-validate="'max:50'" data-vv-as="থানা"
                                            class="form-control-custom" :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_police_station_bn ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_police_station_bn ? false : null">{{
                                                fieldErrors.permanent_police_station_bn }}</b-form-invalid-feedback>
                                    </div>

                                    <!-- Post Office -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">Post Office *:</label>
                                        <b-form-input v-model="form.permanent_post_office.en"
                                            name="permanent_post_office_en" v-validate="'max:25'"
                                            data-vv-as="Post Office (English)" class="form-control-custom"
                                            :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_post_office_en ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_post_office_en ? false : null">{{
                                                fieldErrors.permanent_post_office_en }}</b-form-invalid-feedback>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">ডাকঘর *:</label>
                                        <b-form-input v-model="form.permanent_post_office.bn"
                                            name="permanent_post_office_bn" v-validate="'max:50'" data-vv-as="ডাকঘর"
                                            class="form-control-custom" :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_post_office_bn ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_post_office_bn ? false : null">{{
                                                fieldErrors.permanent_post_office_bn }}</b-form-invalid-feedback>
                                    </div>

                                    <!-- Village/Area -->
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">Village/Area *:</label>
                                        <b-input-group>
                                            <template #prepend>
                                                <!-- alpha fix- added class roiunded-right  -->
                                                <b-form-select v-model="addr_prefix" :options="['Village', 'Area']"
                                                    class="rounded-left rounded-right"
                                                    :disabled="!isEditMode"></b-form-select>
                                            </template>
                                            <b-form-input v-model="form.permanent_village.en"
                                                name="permanent_village_en" v-validate="'max:25'"
                                                data-vv-as="Village/Area (English)" class="form-control-custom"
                                                :readonly="!isEditMode"
                                                :state="fieldErrors.permanent_village_en ? false : null"></b-form-input>
                                        </b-input-group>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_village_en ? false : null">{{
                                                fieldErrors.permanent_village_en
                                            }}</b-form-invalid-feedback>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">স্থায়ী গ্রাম/মহল্লা *:</label>
                                        <b-form-input v-model="form.permanent_village.bn" name="permanent_village_bn"
                                            v-validate="'max:50'" data-vv-as="স্থায়ী গ্রাম/মহল্লা"
                                            class="form-control-custom" :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_village_bn ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_village_bn ? false : null">{{
                                                fieldErrors.permanent_village_bn }}</b-form-invalid-feedback>
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">Road *:</label>
                                        <b-form-input v-model="form.permanent_road.en" name="permanent_road_en"
                                            v-validate="'max:35'" data-vv-as="Road (English)"
                                            class="form-control-custom" :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_road_en ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_road_en ? false : null">{{
                                                fieldErrors.permanent_road_en
                                            }}</b-form-invalid-feedback>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label class="label-custom">রাস্তা *:</label>
                                        <b-form-input v-model="form.permanent_road.bn" name="permanent_road_bn"
                                            v-validate="'max:50'" data-vv-as="রাস্তা" class="form-control-custom"
                                            :readonly="!isEditMode"
                                            :state="fieldErrors.permanent_road_bn ? false : null"></b-form-input>
                                        <b-form-invalid-feedback
                                            :state="fieldErrors.permanent_road_bn ? false : null">{{
                                                fieldErrors.permanent_road_bn
                                            }}</b-form-invalid-feedback>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- Photo Upload Section -->
                        <div class="col-md-3">
                            <div class="photo-container text-center mb-3">
                                <label class="label-custom d-block">Passport Size Photo:</label>
                                <div v-if="photo_preview" class="mt-2 text-center">
                                    <img :src="photo_preview" alt="Worker Photo"
                                        class="rounded border mb-2 mx-auto d-block"
                                        style="width: 45mm; height: 55mm; object-fit: cover" />
                                </div>
                                <div v-else
                                    class="no-photo rounded border mb-2 d-flex align-items-center justify-content-center text-muted mx-auto"
                                    style="width: 45mm; height: 55mm; background-color: #f8f9fa">
                                    <small>No Photo</small>
                                </div>
                                <!--Profile Photo is Imported From Employee Profile, No Upload Options-->
                            </div>
                        </div>
                    </div>

                    <!-- Present Address — Updated by Jarir 2026-04-20 — EN autoflows from Employee Profile address (readonly); BN editable -->
                    <div class="mb-4 mt-2">
                        <label class="label-custom">Present Address :</label>
                        <b-form-textarea v-model="form.present_address.en" rows="1" class="form-control-custom mb-1"
                            readonly></b-form-textarea>
                        <label class="label-custom">বর্তমান ঠিকানা *:</label>
                        <b-form-textarea v-model="form.present_address.bn" name="present_address_bn"
                            v-validate="'max:250'" data-vv-as="বর্তমান ঠিকানা" rows="1" class="form-control-custom"
                            :readonly="!isEditMode"
                            :state="fieldErrors.present_address_bn ? false : null"></b-form-textarea>
                        <b-form-invalid-feedback :state="fieldErrors.present_address_bn ? false : null">{{
                            fieldErrors.present_address_bn
                            }}</b-form-invalid-feedback>
                    </div>

                    <!-- Row of 2 -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Date of Birth জন্ম তারিখ (yyyy-mm-dd) (বছর-মাস-দিন):</label>
                            <b-input-group>
                                <b-form-input v-model="form.dob" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                    class="form-control-custom" readonly></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="form.dob" button-only right locale="en-US"
                                        disabled></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                        <div class="col-md-6 mb-3">
                            <!--NID can't Be edited, readonly-->
                            <label class="label-custom">National ID Number জাতীয় পরিচয়পত্র নং (if available)(যদি উপলব্ধ
                                থাকে):</label>
                            <!-- Updated by Jarir 2026-04-20 — NID autoflows from Employee profile, readonly, not saved; validation removed to avoid blocking save on legacy bad DB values -->
                            <b-form-input v-model="form.nid_number" type="text" class="form-control-custom"
                                readonly></b-form-input>
                        </div>
                        <!-- Updated by Jarir 2026-04-21 — Educational Qualification is a dropdown (9 standardised levels) -->
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Educational Qualification *:</label>
                            <b-form-select v-model="form.educational_qualification.en" :options="educationOptions"
                                class="form-control-custom mb-1" :disabled="!isEditMode"
                                :state="isEditMode && submitAttempted && !form.educational_qualification.en ? false : null"
                                @change="onEducationChange"></b-form-select>
                            <b-form-invalid-feedback
                                :state="isEditMode && submitAttempted && !form.educational_qualification.en ? false : null">Educational
                                Qualification (English) is required</b-form-invalid-feedback>
                            <label class="label-custom">শিক্ষাগত যোগ্যতা *:</label>
                            <b-form-select v-model="form.educational_qualification.bn" :options="educationOptionsBn"
                                class="form-control-custom" :disabled="!isEditMode"
                                :state="isEditMode && submitAttempted && !form.educational_qualification.bn ? false : null"></b-form-select>
                            <b-form-invalid-feedback
                                :state="isEditMode && submitAttempted && !form.educational_qualification.bn ? false : null">শিক্ষাগত
                                যোগ্যতা
                                (Bangla) is required</b-form-invalid-feedback>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Training or Special Skills :</label>
                            <b-form-input v-model="form.training_special_skills.en" name="training_special_skills_en"
                                v-validate="'max:50'" data-vv-as="Training or Special Skills (English)"
                                class="form-control-custom mb-1" :readonly="!isEditMode"
                                :state="fieldErrors.training_special_skills_en ? false : null"></b-form-input>
                            <b-form-invalid-feedback :state="fieldErrors.training_special_skills_en ? false : null">{{
                                fieldErrors.training_special_skills_en }}</b-form-invalid-feedback>
                            <label class="label-custom">প্রশিক্ষণ বা বিশেষ দক্ষতা :</label>
                            <b-form-input v-model="form.training_special_skills.bn" name="training_special_skills_bn"
                                v-validate="'max:70'" data-vv-as="প্রশিক্ষণ বা বিশেষ দক্ষতা" class="form-control-custom"
                                :readonly="!isEditMode"
                                :state="fieldErrors.training_special_skills_bn ? false : null"></b-form-input>
                            <b-form-invalid-feedback :state="fieldErrors.training_special_skills_bn ? false : null">{{
                                fieldErrors.training_special_skills_bn }}</b-form-invalid-feedback>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Height উচ্চতা:</label>
                            <b-form-input v-model="form.height" class="form-control-custom" :readonly="!isEditMode"
                                :state="isEditMode && form.height ? (isHeightValid(form.height) ? null : false) : null"></b-form-input>
                            <b-form-invalid-feedback
                                :state="isEditMode && form.height && !isHeightValid(form.height) ? false : null">Height
                                contains invalid characters. Use formats like 5 Feet 7, 5'7"</b-form-invalid-feedback>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Blood Group রক্তের গ্রুপ (if known)(যদি জানা থাকে):</label>
                            <!-- Blood Group is Imported From Employee Profile, No Dropdown Options -->
                            <b-form-select v-model="form.blood_group" :options="bloodGroupOptions"
                                class="form-control-custom" disabled></b-form-select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Any Identification mark(If available) :</label>
                            <!-- Updated by Tareq Sifat 2026-08-02 — name + max rule added. Without them
                   veeErrors never held an entry for this field, so typing past the limit produced
                   no character-limit message at all, unlike its Bangla counterpart below. -->
                            <b-form-input v-model="form.identification_mark.en" name="identification_mark_en"
                                v-validate="'max:50'" data-vv-as="Identification Mark (English)"
                                class="form-control-custom mb-1" :readonly="!isEditMode"
                                :state="fieldErrors.identification_mark_en ? false : null"></b-form-input>
                            <b-form-invalid-feedback :state="fieldErrors.identification_mark_en ? false : null">{{
                                fieldErrors.identification_mark_en }}</b-form-invalid-feedback>
                            <label class="label-custom">সনাক্ত করার চিহ্ন(যদি উপলব্ধ থাকে) :</label>
                            <b-form-input v-model="form.identification_mark.bn" name="identification_mark_bn"
                                v-validate="'max:70'" data-vv-as="সনাক্ত করার চিহ্ন" class="form-control-custom"
                                :readonly="!isEditMode"
                                :state="fieldErrors.identification_mark_bn ? false : null"></b-form-input>
                            <b-form-invalid-feedback :state="fieldErrors.identification_mark_bn ? false : null">{{
                                fieldErrors.identification_mark_bn }}</b-form-invalid-feedback>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="label-custom">Date of Service Book Opening সার্ভিস বুক খোলার তারিখ *:</label>
                            <b-input-group>
                                <b-form-input v-model="form.opening_date" type="text" placeholder="YYYY-MM-DD"
                                    autocomplete="off" class="form-control-custom" :readonly="!isEditMode"
                                    :state="fieldErrors.opening_date ? false : null"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="form.opening_date" button-only right locale="en-US"
                                        :disabled="!isEditMode"></b-form-datepicker>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="fieldErrors.opening_date ? false : null">{{
                                fieldErrors.opening_date
                                }}</b-form-invalid-feedback>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <!-- Worker's Signature — Updated by Jarir 2026-04-20: auto-synced from Employee profile, no manual upload -->
                        <div class="col-md-4">
                            <label class="label-custom d-block" style="min-height: 2.6em">Worker's Signature শ্রমিকের
                                স্বাক্ষর:</label>
                            <div v-if="sig_preview" class="sig-container mb-2">
                                <b-link @click="downloadWithName(getImageUrl(form.signature), 'Worker_Signature')">
                                    <b-icon icon="download" scale="1.2"></b-icon> Download
                                </b-link>
                            </div>
                            <div v-else class="text-muted small">No signature on file. Upload the worker's signature in
                                the Employee Profile
                                via ESS Portal.</div>
                        </div>

                        <!-- Worker's Thumb Impression -->
                        <div class="col-md-4">
                            <label class="label-custom d-block" style="min-height: 2.6em">Worker's Thumb Impression
                                শ্রমিকের বৃদ্ধাঙ্গুলির
                                ছাপ:</label>
                            <div v-if="form.worker_thumb_impression" class="mt-2">
                                <b-link
                                    @click="downloadWithName(form.worker_thumb_impression, 'Worker_Thumb_Impression')">
                                    <b-icon icon="download" scale="1.2"></b-icon> Download
                                </b-link>
                            </div>
                        </div>

                        <!-- Owner's Signature — Updated by Jarir 2026-03-30 -->
                        <div class="col-md-4">
                            <label class="label-custom d-block" style="min-height: 2.6em">Owner's signature
                                মালিক/ব্যবস্থাপক/কর্তৃপক্ষের
                                স্বাক্ষর:</label>
                            <div v-if="owner_sig_preview" class="sig-container mb-2">
                                <b-link
                                    @click="downloadWithName(owner_sig_raw || getImageUrl(form.owner_signature), 'Owner_Signature')">
                                    <b-icon icon="download" scale="1.2"></b-icon> Download
                                </b-link>
                            </div>
                            <template v-if="isAdmin">
                                <div v-if="!owner_sig_preview" class="text-muted small">No Signatories found. Add a
                                    Signatory in HR Management Portal</div>
                                <!-- Updated by Jarir 2026-04-26 — Signatory selection restricted to Admin side only -->
                                <b-form-select v-model="selected_signatory_id" :options="signatoryOptions"
                                    :disabled="!isEditMode" class="mt-2" @change="onSignatoryChange"></b-form-select>
                            </template>
                            <div v-else-if="!owner_sig_preview" class="text-muted small">No owner signature available.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>
<script>
export default {
    props: {
        isEmbedded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            apiPrefix: "/admin-service-book",
            employee_id: null,
            loading: false,
            pdfLoading: false,
            isEditMode: false,
            addr_prefix: "Village",
            photo_preview: null,
            sig_preview: null,
            thumb_preview: null,
            owner_sig_preview: null,
            owner_sig_raw: null,
            signatories: [],
            selected_signatory_id: null,
            thumb_file: null,
            thumb_name: "",
            owner_sig_name: "",
            nidError: "",
            locations: [],
            // Updated by Jarir 2026-04-09 — Bangla locations for BN dropdowns
            locationsBn: [],
            bloodGroupOptions: [
                { value: "", text: "Select Blood Group" },
                "A+",
                "A-",
                "B+",
                "B-",
                "O+",
                "O-",
                "AB+",
                "AB-",
            ],
            // Updated by Jarir 2026-04-21 — standardised education levels for EN/BN dropdowns
            educationOptions: [
                { value: "", text: "Select Qualification" },
                "No Formal Education",
                "Primary Education / Class 5",
                "Junior School Certificate (JSC) / Class 8",
                "Secondary School Certificate (SSC) / Dakhil / Equivalent",
                "Higher Secondary Certificate (HSC) / Alim / Vocational Diploma / Equivalent",
                "Bachelor's Degree (Pass) / Pass Course",
                "Bachelor's Degree (Honours) / Equivalent",
                "Master's Degree",
                "Doctorate or Higher (PhD/MPhil)",
            ],
            educationOptionsBn: [
                { value: "", text: "যোগ্যতা নির্বাচন করুন" },
                "প্রাতিষ্ঠানিক শিক্ষা নেই",
                "প্রাথমিক শিক্ষা / পঞ্চম শ্রেণি",
                "জুনিয়র স্কুল সার্টিফিকেট (জেএসসি) / অষ্টম শ্রেণি",
                "মাধ্যমিক স্কুল সার্টিফিকেট (এসএসসি) / দাখিল / সমমান",
                "উচ্চ মাধ্যমিক সার্টিফিকেট (এইচএসসি) / আলিম / ভোকেশনাল ডিপ্লোমা / সমমান",
                "স্নাতক (পাস) / পাস কোর্স",
                "স্নাতক (সম্মান) / সমমান",
                "স্নাতকোত্তর (মাস্টার্স)",
                "ডক্টরেট বা উচ্চতর (পিএইচডি / এমফিল)",
            ],
            // Updated 2026-07-30 — single source of truth for per-field validation. The template, the
            // save and the error text all read this one table, so they cannot drift apart: the template
            // used to accept "Md. Karim" in Father's Name while the save rejected it, failing with
            // nothing marked red and no message anywhere.
            //   requiredMsg = shown when empty (after a save attempt)
            //   re          = the whole value must match this (msg on failure)
            //   must        = the value must contain this (mustMsg on failure)
            // Max lengths stay on the fields as v-validate rules; their message comes from veeErrors.
            fieldRules: [
                { key: "worker_name", lang: "bn", re: /^[\u0980-\u09FF ]+$/, msg: "Worker's Name (Bangla) can only contain Bangla letters and spaces" },
                { key: "father_name", lang: "en", requiredMsg: "Father's Name (English) is required", re: /^[A-Za-z .,-]+$/, msg: "Father's Name (English) can only contain English letters, spaces, dots, commas and dashes" },
                { key: "father_name", lang: "bn", requiredMsg: "Father's Name (Bangla) is required", re: /^[\u0980-\u09FF .,-]+$/, msg: "Father's Name (Bangla) can only contain Bangla letters, spaces, dots, commas and dashes" },
                { key: "mother_name", lang: "en", requiredMsg: "Mother's Name (English) is required", re: /^[A-Za-z ]+$/, msg: "Mother's Name (English) can only contain English letters and spaces" },
                { key: "mother_name", lang: "bn", requiredMsg: "Mother's Name (Bangla) is required", re: /^[\u0980-\u09FF ]+$/, msg: "Mother's Name (Bangla) can only contain Bangla letters and spaces" },
                { key: "spouse_name", lang: "bn", re: /^[\u0980-\u09FF ]+$/, msg: "Spouse's Name (Bangla) can only contain Bangla letters and spaces" },
                { key: "permanent_police_station", lang: "en", requiredMsg: "Police Station (English) is required", must: /[A-Za-z]/, mustMsg: "Police Station (English) must contain at least one English letter" },
                { key: "permanent_police_station", lang: "bn", requiredMsg: "Police Station (Bangla) is required", must: /[\u0980-\u09FF]/, mustMsg: "Police Station (Bangla) must contain at least one Bangla letter" },
                { key: "permanent_post_office", lang: "en", requiredMsg: "Post Office (English) is required", must: /[A-Za-z]/, mustMsg: "Post Office (English) must contain at least one English letter" },
                { key: "permanent_post_office", lang: "bn", requiredMsg: "ডাকঘর (Bangla) is required", must: /[\u0980-\u09FF]/, mustMsg: "Post Office (Bangla) must contain at least one Bangla letter" },
                { key: "permanent_village", lang: "en", requiredMsg: "Village/Area (English) is required", must: /[A-Za-z]/, mustMsg: "Village/Area (English) must contain at least one English letter" },
                { key: "permanent_village", lang: "bn", requiredMsg: "গ্রাম/মহল্লা (Bangla) is required", must: /[\u0980-\u09FF]/, mustMsg: "Village/Area (Bangla) must contain at least one Bangla letter" },
                { key: "permanent_road", lang: "en", requiredMsg: "Road (English) is required", must: /[A-Za-z0-9]/, mustMsg: "Road (English) must contain letters or numbers" },
                { key: "permanent_road", lang: "bn", requiredMsg: "রাস্তা (Bangla) is required", must: /[\u0980-\u09FF0-9]/, mustMsg: "Road (Bangla) must contain Bangla letters or numbers" },
                { key: "present_address", lang: "bn", requiredMsg: "বর্তমান ঠিকানা (Bangla) is required", must: /[\u0980-\u09FF0-9]/, mustMsg: "বর্তমান ঠিকানা must contain Bangla letters or numbers" },
                // Updated by Tareq Sifat 2026-08-02 \u2014 these four accept exactly what sanitizeEnText /
                // sanitizeBnText allow and what ServiceBookImportExportController's bulk-import checks allow:
                // digits, dots, dashes and the Bangla dari. They used to be narrower than both, so an
                // ordinary Bangla sentence ending in "\u0964" was refused here while the same text imported from
                // Excel without complaint.
                { key: "training_special_skills", lang: "en", re: /^[A-Za-z0-9 ,.\-]+$/, msg: "Training/Skills (English) can only contain English letters, digits, spaces, commas, dots and dashes", must: /[A-Za-z]/, mustMsg: "Training/Skills (English) must contain at least one English letter" },
                { key: "training_special_skills", lang: "bn", re: /^[\u0980-\u09FF0-9 ,\u0964\-]+$/, msg: "Training/Skills (Bangla) can only contain Bangla letters, digits, spaces, commas, dari and dashes", must: /[\u0980-\u09FF]/, mustMsg: "Training/Skills (Bangla) must contain at least one Bangla letter" },
                { key: "identification_mark", lang: "en", re: /^[A-Za-z0-9 ,.\-]+$/, msg: "Identification Mark (English) can only contain English letters, digits, spaces, commas, dots and dashes", must: /[A-Za-z]/, mustMsg: "Identification Mark (English) must contain at least one English letter" },
                { key: "identification_mark", lang: "bn", re: /^[\u0980-\u09FF0-9 ,\u0964\-]+$/, msg: "Identification Mark (Bangla) can only contain Bangla letters, digits, spaces, commas, dari and dashes", must: /[\u0980-\u09FF]/, mustMsg: "Identification Mark (Bangla) must contain at least one Bangla letter" },
                { key: "opening_date", lang: null, requiredMsg: "Service Book Opening Date is required", re: /^\d{4}-\d{2}-\d{2}$/, msg: "Service Book Opening Date must be in YYYY-MM-DD format" },
            ],
            form: {
                worker_name: { en: "", bn: "" },
                father_name: { en: "", bn: "" },
                mother_name: { en: "", bn: "" },
                spouse_name: { en: "", bn: "" },
                permanent_village: { en: "", bn: "" },
                permanent_road: { en: "", bn: "" },
                permanent_post_office: { en: "", bn: "" },
                permanent_police_station: { en: "", bn: "" },
                permanent_sub_district: { en: "", bn: "" },
                permanent_district: { en: "", bn: "" },
                present_address: { en: "", bn: "" },
                dob: "",
                nid_number: "",
                educational_qualification: { en: "", bn: "" },
                training_special_skills: { en: "", bn: "" },
                height: "",
                blood_group: "",
                identification_mark: { en: "", bn: "" },
                opening_date: "",
            },
            // Updated by Jarir 2026-04-26 — track submit attempts for inline validation
            submitAttempted: false,
        };
    },
    // Updated by Jarir 2026-04-20 — strip special chars from editable text fields
    // EN fields allow A-Z a-z 0-9 space only; BN fields allow Bangla Unicode + digits + space
    watch: {
        form: {
            deep: true,
            handler: function () {
                this.sanitizeAllFormFields();
            },
        },
    },
    computed: {
        // Updated 2026-07-30 — { field: message } holding at most ONE message per field, in priority
        // order: required, then max length, then content. One message per field is what lets the
        // template render a single feedback element: a stack of them all light up together, because
        // Bootstrap shows every .invalid-feedback that follows an .is-invalid control in the same
        // parent — which is how a filled-in field ended up claiming it was required.
        // Updated by Tareq Sifat 2026-08-02 — max length now outranks the content rules. It used to come
        // last, so an over-long value that also tripped a content rule reported the content problem and
        // the character limit was never mentioned: a perfectly valid Bangla identification mark typed
        // past 70 characters read "must contain at least one Bangla letter", which is both wrong and no
        // help in fixing it. Length is the more specific complaint whenever both apply.
        fieldErrors() {
            const found = {};
            if (!this.isEditMode) return found;
            this.fieldRules.forEach((rule) => {
                const id = rule.lang ? rule.key + "_" + rule.lang : rule.key;
                const group = this.form[rule.key];
                const value = (rule.lang ? (group ? group[rule.lang] : "") : group) || "";
                if (!value) {
                    if (rule.requiredMsg && this.submitAttempted) found[id] = rule.requiredMsg;
                    return;
                }
                if (this.veeErrors.has(id)) {
                    found[id] = this.veeErrors.first(id);
                } else if (rule.re && !rule.re.test(value)) {
                    found[id] = rule.msg;
                } else if (rule.must && !rule.must.test(value)) {
                    found[id] = rule.mustMsg;
                }
            });
            return found;
        },
        isAdmin() {
            return this.apiPrefix === "/admin-service-book";
        },
        // Updated by Jarir 2026-03-30
        signatoryOptions() {
            var options = [{ value: null, text: 'Select Signatory' }];
            this.signatories.forEach(function (s) {
                options.push({ value: s.id, text: s.name + ' — ' + (s.designation || '') });
            });
            return options;
        },
        districtOptions() {
            const districts = [
                ...new Set(this.locations.map((item) => item.district)),
            ];
            return [
                { value: "", text: "Select District" },
                ...districts.sort().map((d) => ({ value: d, text: d })),
            ];
        },
        districtOptions() {
            const districts = [
                ...new Set(this.locations.map((item) => item.district)),
            ];
            return [
                { value: "", text: "Select District" },
                ...districts.sort().map((d) => ({ value: d, text: d })),
            ];
        },
        subdistrictOptions() {
            if (!this.form.permanent_district.en)
                return [{ value: "", text: "Select Sub-district" }];
            const subdistricts = [
                ...new Set(
                    this.locations
                        .filter((item) => item.district === this.form.permanent_district.en)
                        .map((item) => item.subdistrict),
                ),
            ];
            return [
                { value: "", text: "Select Sub-district" },
                ...subdistricts.sort().map((s) => ({ value: s, text: s })),
            ];
        },
        // Updated by Jarir 2026-04-09 — BN dropdown options sourced from Bangla locations file (independent from EN side)
        districtOptionsBn() {
            const districts = [
                ...new Set(this.locationsBn.map((item) => item.district)),
            ];
            return [
                { value: "", text: "জেলা নির্বাচন করুন" },
                ...districts.sort().map((d) => ({ value: d, text: d })),
            ];
        },
        subdistrictOptionsBn() {
            if (!this.form.permanent_district.bn)
                return [{ value: "", text: "উপজেলা নির্বাচন করুন" }];
            const subdistricts = [
                ...new Set(
                    this.locationsBn
                        .filter((item) => item.district === this.form.permanent_district.bn)
                        .map((item) => item.subdistrict),
                ),
            ];
            return [
                { value: "", text: "উপজেলা নির্বাচন করুন" },
                ...subdistricts.sort().map((s) => ({ value: s, text: s })),
            ];
        },
        postofficeOptions() {
            if (!this.form.permanent_sub_district.en)
                return [{ value: "", text: "Select Post Office" }];
            const postoffices = [
                ...new Set(
                    this.locations
                        .filter(
                            (item) =>
                                item.district === this.form.permanent_district.en &&
                                item.subdistrict === this.form.permanent_sub_district.en,
                        )
                        .map((item) => item.postoffice),
                ),
            ];
            return [
                { value: "", text: "Select Post Office" },
                ...postoffices.sort().map((p) => ({ value: p, text: p })),
            ];
        },
    },
    created() {
        this.fetchData();
        this.fetchLocations();
        this.fetchSignatories();
    },
    methods: {
        // Updated by Jarir 2026-04-20 — strip disallowed chars from editable form inputs.
        // EN fields: only A-Z a-z 0-9 space; BN fields: only Bangla Unicode (U+0980–U+09FF) + 0-9 + space.
        // Readonly fields (worker_name.en, spouse_name.en, present_address.en, dob, nid_number) are skipped
        // because they auto-flow from Employee Profile and aren't user-typed here.
        sanitizeEnText: function (v) {
            if (v == null) return v;
            // Updated by Jarir 2026-04-21 : Allow A-Z, a-z, 0-9, space, comma, dot, dash
            return String(v).replace(/[^A-Za-z0-9 ,.\-]/g, "");
        },
        sanitizeBnText: function (v) {
            if (v == null) return v;
            // Updated by Jarir 2026-04-21 : Allow Bangla Unicode, 0-9, space, comma, dash, dari
            return String(v).replace(/[^\u0980-\u09FF0-9 ,।\-]/g, "");
        },
        sanitizeAllFormFields: function () {
            // Updated by Jarir 2026-04-21 — Names (Worker, Father, Mother, Spouse) are excluded from automatic stripping
            // so that saveData validation can catch invalid characters (numbers/special chars) and show errors.
            var enFields = [];
            var bnFields = [];
            for (var i = 0; i < enFields.length; i++) {
                var k = enFields[i];
                if (this.form[k] && typeof this.form[k] === "object" && "en" in this.form[k]) {
                    var cleanEn = this.sanitizeEnText(this.form[k].en);
                    if (cleanEn !== this.form[k].en) this.$set(this.form[k], "en", cleanEn);
                }
            }
            for (var j = 0; j < bnFields.length; j++) {
                var kb = bnFields[j];
                if (this.form[kb] && typeof this.form[kb] === "object" && "bn" in this.form[kb]) {
                    var cleanBn = this.sanitizeBnText(this.form[kb].bn);
                    if (cleanBn !== this.form[kb].bn) this.$set(this.form[kb], "bn", cleanBn);
                }
            }
            // Height — auto-sanitization disabled to allow symbols/Bangla characters; validated in saveData
            // var cleanHeight = this.sanitizeEnText(this.form.height);
            // if (cleanHeight !== this.form.height) this.form.height = cleanHeight;
        },
        // Updated by Jarir 2026-04-09 — Recursively scan form for HTML tags / PHP code, return offending field path or null
        findHtmlOrPhpField(data, prefix) {
            const pattern = /<[a-zA-Z!?\/]/;
            if (data === null || data === undefined) return null;
            if (typeof data === "string") {
                if (data && pattern.test(data)) return prefix || "field";
                return null;
            }
            if (typeof data === "object") {
                for (const key in data) {
                    if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
                    const field = prefix ? prefix + "." + key : key;
                    const hit = this.findHtmlOrPhpField(data[key], field);
                    if (hit) return hit;
                }
            }
            return null;
        },
        fetchAsBlob(url) {
            if (!url) return Promise.resolve(null);
            return fetch(url, { credentials: 'same-origin' })
                .then(r => r.blob())
                .then(blob => URL.createObjectURL(blob))
                .catch(() => null); // return null on failure; never fall back to the raw path
        },
        // Updated by Jarir 2026-04-20 — Converted GET→POST; fetch both EN and BN location datasets in parallel
        fetchLocations() {
            axios
                .post(this.$api_url + this.apiPrefix + "/get-locations", {})
                .then((response) => {
                    this.locations = response.data;
                })
                .catch((error) => {
                    console.error("Error loading locations:", error);
                });
            axios
                .post(this.$api_url + this.apiPrefix + "/get-locations", { lang: "bn" })
                .then((response) => {
                    this.locationsBn = response.data;
                })
                .catch((error) => {
                    console.error("Error loading Bangla locations:", error);
                });
        },
        // Updated by Jarir 2026-03-30
        // Updated by Jarir 2026-04-23 — removed employee_id from body; backend reads from session only
        fetchSignatories() {
            axios
                .post(this.$api_url + this.apiPrefix + "/get-signatories", {})
                .then((response) => {
                    this.signatories = response.data || [];
                })
                .catch((error) => {
                    console.error("Error loading signatories:", error);
                });
        },
        onSignatoryChange(sigId) {
            if (!sigId) {
                this.owner_sig_preview = null;
                return;
            }
            var found = null;
            for (var i = 0; i < this.signatories.length; i++) {
                if (this.signatories[i].id == sigId) {
                    found = this.signatories[i];
                    break;
                }
            }
            if (found && found.signature) {
                var path = '/images/company/signature/' + found.signature;
                // Reset first so the Download link stays hidden until the blob is ready;
                // owner_sig_raw is set to the blob URL (not the raw path) to prevent
                // downloadWithName from navigating the browser to a server URL.
                this.owner_sig_raw = null;
                this.owner_sig_preview = null;
                this.fetchAsBlob(path).then(function (b) {
                    this.owner_sig_preview = b;
                    this.owner_sig_raw = b; // use blob URL for download
                }.bind(this));
            } else {
                this.owner_sig_preview = null;
                this.owner_sig_raw = null;
            }
        },
        onDistrictChange(val) {
            this.form.permanent_sub_district.en = "";
            this.form.permanent_sub_district.bn = "";
            this.form.permanent_post_office.en = "";
            this.form.permanent_post_office.bn = "";

            // Updated by Jarir 2026-05-04 — auto-select BN district based on index parity
            if (val) {
                const index = this.locations.findIndex(item => item.district === val);
                if (index !== -1 && this.locationsBn[index]) {
                    this.form.permanent_district.bn = this.locationsBn[index].district;
                }
            } else {
                this.form.permanent_district.bn = "";
            }
        },
        onSubDistrictChange(val) {
            this.form.permanent_post_office.en = "";
            this.form.permanent_post_office.bn = "";

            // Updated by Jarir 2026-05-04 — auto-select BN sub-district based on index parity
            if (val) {
                const index = this.locations.findIndex(item =>
                    item.district === this.form.permanent_district.en &&
                    item.subdistrict === val
                );
                if (index !== -1 && this.locationsBn[index]) {
                    this.form.permanent_sub_district.bn = this.locationsBn[index].subdistrict;
                }
            } else {
                this.form.permanent_sub_district.bn = "";
            }
        },
        onEducationChange(val) {
            // Updated by Jarir 2026-05-04 — auto-select BN education based on index
            if (!val) {
                this.form.educational_qualification.bn = "";
                return;
            }
            const index = this.educationOptions.findIndex(o => (typeof o === 'string' ? o : o.value) === val);
            if (index !== -1 && this.educationOptionsBn[index]) {
                const bnOption = this.educationOptionsBn[index];
                this.form.educational_qualification.bn = typeof bnOption === 'string' ? bnOption : bnOption.value;
            }
        },
        fetchData() {
            this.loading = true;
            const targetUrl = this.apiPrefix + "/worker-identification";

            axios
                .get(targetUrl)
                .then((response) => {
                    if (response.data) {
                        const doc = response.data;

                        // Safe JSON parsing for multilingual fields
                        const fields = [
                            "worker_name",
                            "father_name",
                            "mother_name",
                            "spouse_name",
                            "permanent_village",
                            "permanent_road",
                            "permanent_post_office",
                            "permanent_police_station",
                            "permanent_sub_district",
                            "permanent_district",
                            "present_address",
                            "educational_qualification",
                            "training_special_skills",
                            "identification_mark",
                        ];

                        fields.forEach((field) => {
                            doc[field] = this.getJsonValue(doc[field]);
                        });

                        this.form = Object.assign({}, this.form, doc);

                        // Updated by Jarir 2026-04-20 — Sanitize legacy literal "null" strings from DB so readonly autoflow fields display clean
                        ['nid_number', 'blood_group', 'dob'].forEach((k) => {
                            if (this.form[k] == 'null' || this.form[k] == null) this.form[k] = '';
                        });

                        // Trim ISO timestamps to YYYY-MM-DD
                        if (this.form.dob) this.form.dob = (this.form.dob + '').substring(0, 10);
                        if (this.form.opening_date) this.form.opening_date = (this.form.opening_date + '').substring(0, 10);

                        if (this.form.photo) {
                            this.fetchAsBlob(this.getImageUrl(this.form.photo))
                                .then(b => { this.photo_preview = b; });
                        } else {
                            this.photo_preview = null;
                        }
                        if (this.form.signature) {
                            this.fetchAsBlob(this.getImageUrl(this.form.signature))
                                .then(b => { this.sig_preview = b; });
                        } else {
                            this.sig_preview = null;
                        }
                        if (this.form.worker_thumb_impression) {
                            this.fetchAsBlob(this.getImageUrl(this.form.worker_thumb_impression))
                                .then(b => { this.thumb_preview = b; });
                        } else {
                            this.thumb_preview = null;
                        }
                        // Set selected signatory from saved data — Updated by Jarir 2026-03-30
                        if (this.form.signatory_id) {
                            this.selected_signatory_id = this.form.signatory_id;
                        }

                        if (this.form.owner_signature) {
                            this.fetchAsBlob(this.getImageUrl(this.form.owner_signature))
                                .then(b => { this.owner_sig_preview = b; });
                        } else {
                            this.owner_sig_preview = null;
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error fetching service book data:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getImageUrl(path) {
            if (!path) return null;
            if (
                path.startsWith("http://") ||
                path.startsWith("https://") ||
                path.startsWith("data:")
            ) {
                return path;
            }
            return "/" + path;
        },
        // Updated by Jarir 2026-04-26 — backend streams PDF directly; use blob responseType
        downloadPdf(lang = "both") {
            this.pdfLoading = true;
            axios
                .post(
                    this.$api_url + this.apiPrefix + "/download-worker-identification-pdf",
                    { lang: lang },
                    { responseType: "blob" },
                )
                .then((response) => {
                    this.global_download_file_content(response);
                })
                .catch((error) => {
                    console.error("Error downloading PDF:", error);
                    this.$bvToast.toast("Error downloading PDF", {
                        title: "Error", variant: "danger", solid: true, autoHideDelay: 5000,
                    });
                })
                .finally(() => {
                    this.pdfLoading = false;
                });
        },
        // Updated 2026-07-30 — vee-validate gate. The per-field max-length rules run before anything else:
        // any over-limit field keeps its message and the save is blocked, so nothing is silently truncated
        // or saved too long. Values loaded over the limit from the DB are caught here too.
        saveData() {
            this.submitAttempted = true;
            this.$validator.validateAll().then((valid) => {
                if (!valid) {
                    this.$bvToast.toast('Please fix the highlighted fields [marked red]', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000,
                    });
                    return;
                }
                this.saveValidatedData();
            });
        },
        saveValidatedData() {
            // Updated by Jarir 2026-04-20 — NID / DOB / blood group auto-flow from Employee profile and are excluded from the save payload, so skip NID format validation here (bad values in DB shouldn't block unrelated saves)

            let errors = [];

            // Updated by Jarir 2026-04-09 — Block HTML tags / PHP code in any text field before save
            const badField = this.findHtmlOrPhpField(this.form);
            if (badField) {
                // Updated 2026-07-30 — no field is marked red for this, so name the real problem instead
                // of the generic "fill all required fields" toast
                this.$bvToast.toast("HTML tags or code are not allowed in " + badField, {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                });
                return;
            }

            // Updated 2026-07-30 — required, content and length messages all come from fieldRules, the
            // same table the fields are painted with, so every error reported here is visible on the
            // field that caused it. Only the dropdowns are checked separately.
            Object.keys(this.fieldErrors).forEach((id) => {
                errors.push(this.fieldErrors[id]);
            });

            // Updated by Jarir 2026-04-21 : Height validation (using helper method)
            if (this.form.height && !this.isHeightValid(this.form.height)) {
                errors.push("Height contains invalid characters or format. Use formats like 5 Feet 7, 5'7\", ৫ ফুট ৭ ইঞ্চি etc.");
            }

            if (!this.form.permanent_district.en) errors.push("District (English)");
            if (!this.form.permanent_district.bn) errors.push("District (Bangla)");
            if (!this.form.permanent_sub_district.en) errors.push("Sub-district (English)");
            if (!this.form.permanent_sub_district.bn) errors.push("Sub-district (Bangla)");
            // Updated 2026-07-30 — the field is marked * and the template paints it red when empty, but
            // the save never checked it, so it went red on a save that succeeded
            if (!this.form.educational_qualification.en) errors.push("Educational Qualification (English)");
            if (!this.form.educational_qualification.bn) errors.push("Educational Qualification (Bangla)");


            if (errors.length > 0) {
                this.$bvToast.toast('Please fill all required fields [marked red]', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000,
                });
                return;
            }

            this.loading = true;
            let formData = new FormData();

            // Append all form fields
            const jsonFields = [
                "worker_name",
                "father_name",
                "mother_name",
                "spouse_name",
                "permanent_village",
                "permanent_road",
                "permanent_post_office",
                "permanent_police_station",
                "permanent_sub_district",
                "permanent_district",
                "present_address",
                "educational_qualification",
                "training_special_skills",
                "identification_mark",
            ];

            for (let key in this.form) {
                if (this.form[key] !== null) {
                    // Exclude fields autoloaded from Employee profile - Updated by Jarir 2026-04-19
                    // Updated by Tareq Sifat 2026-08-18 — the image fields are excluded too. The read
                    // endpoint hands them over as `data:image/...;base64,...` (the module never exposes
                    // an image URL), so this loop was posting the whole photograph back as the value of
                    // a column that holds a path, and the save died on "Data too long for column
                    // 'photo'". None of the five is editable on this screen anyway: the photo and both
                    // signatures come from the Employee profile and the signatory picker, and the thumb
                    // impression is appended below as a file when a new one was chosen. The ESS screen
                    // already skipped exactly these.
                    if (['dob', 'nid_number', 'blood_group',
                        'photo', 'fallback_photo', 'signature',
                        'worker_thumb_impression', 'owner_signature'].includes(key)) {
                        continue;
                    }

                    if (jsonFields.includes(key)) {
                        formData.append(key, JSON.stringify(this.form[key]));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }
            }

            // Updated by Jarir 2026-04-23 — employee_id removed from body; backend reads from session only

            // Append selected signatory — Updated by Jarir 2026-03-30
            if (this.selected_signatory_id) {
                formData.set("signatory_id", this.selected_signatory_id);
            }

            // Worker signature is auto-synced from Employee profile — no upload sent — Updated by Jarir 2026-04-20
            if (this.thumb_file) {
                formData.append("worker_thumb_impression", this.thumb_file);
            }
            if (this.$refs.ownerSigInput && this.$refs.ownerSigInput.files[0]) {
                formData.append("owner_signature", this.$refs.ownerSigInput.files[0]);
            }

            axios
                .post(
                    this.$api_url + this.apiPrefix + "/worker-identification",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                )
                .then(() => {
                    // Updated by Jarir 2026-03-24 : disable edit mode after save
                    this.isEditMode = false;
                    this.$bvToast.toast(
                        "Worker Identification Document saved successfully",
                        {
                            title: "Success",
                            variant: "success",
                            solid: true,
                            autoHideDelay: 3000,
                        },
                    );
                })
                .catch(() => {
                    this.$bvToast.toast("Error saving document", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                        autoHideDelay: 5000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // Updated by Jarir 2026-05-04 - detect base64 images and download directly
        downloadWithName(filePath, label) {
            if (!filePath) return;

            var isBase64 = filePath.startsWith('data:image/');
            var workerName = (this.form.worker_name && this.form.worker_name.en) ? this.form.worker_name.en : 'Unknown';
            var safeName = workerName.replace(/[^a-zA-Z0-9]/g, '_');

            var ext = '';
            if (isBase64) {
                // Handle base64: detect extension from mime type and trigger local download
                var mimeMatch = filePath.match(/data:(image\/[a-zA-Z+]+);base64,/);
                if (mimeMatch) {
                    ext = mimeMatch[1].split('/')[1];
                    if (ext === 'jpeg') ext = 'jpg';
                    else if (ext.includes('+xml')) ext = 'svg';
                }
                if (!ext) ext = 'png';
            } else {
                // Handle standard path
                ext = filePath.split('.').pop().toLowerCase();
            }

            var fileName = label + '_of_' + safeName + '.' + ext;

            if (isBase64) {
                // Convert Base64 to Blob and download directly to bypass server request
                var parts = filePath.split(',');
                var byteString = atob(parts[1]);
                var mimeString = parts[0].split(':')[1].split(';')[0];
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                var blob = new Blob([ab], { type: mimeString });
                var blobUrl = window.URL.createObjectURL(blob);

                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                return;
            }

            var config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                responseType: 'blob'
            };
            var formData = new FormData();
            formData.append('tkn', filePath);

            axios.post(this.$api_url + '/ghostme', formData, config)
                .then(function (response) {
                    this.showoverlay = false;

                    // Check if server returned a JSON error
                    if (response.data.type == 'application/json') {
                        var file = new Blob([response.data], { type: 'application/json' });
                        var cast = Promise.resolve(file.text());
                        cast.then(function (value) {
                            var err_obj = JSON.parse(value);
                            this.$bvToast.toast(err_obj.error_msg, {
                                title: 'Error',
                                variant: 'danger',
                                solid: true
                            });
                        }.bind(this));
                    } else {
                        var blob = new Blob([response.data], { type: response.headers['content-type'] });
                        var blobUrl = window.URL.createObjectURL(blob);
                        var link = document.createElement('a');
                        link.href = blobUrl;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl);
                    }
                }.bind(this))
                .catch(function (error) {
                    console.log('Download error:', error);
                });
        },
        // Updated by Jarir 2026-03-29 - uses global checkFileType for validation
        onThumbChange(e) {
            if (!this.checkFileType(e, 'thumb_file', ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.heic', '.tiff', '.avif'])) return;
            const file = e.target.files[0];
            if (file) {
                this.thumb_name = file.name;
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.thumb_preview = event.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        validateNID() {
            const nid = this.form.nid_number;

            if (!nid) {
                this.nidError = "";
                return;
            }

            if (!/^[0-9]+$/.test(nid)) {
                this.nidError = "NID must contain only numbers";
                return;
            }

            if (nid.length < 10) {
                this.nidError = "NID must be at least 10 digits";
                return;
            }

            if (nid.length > 17) {
                this.nidError = "NID must not exceed 17 digits";
                return;
            }

            this.nidError = "";
        },
        onOwnerSigChange(e) {
            const file = e.target.files[0];
            if (file) {
                const extension = file.name.split(".").pop().toLowerCase();
                const allowedExtensions = [
                    "jpg",
                    "jpeg",
                    "png",
                    "gif",
                    "bmp",
                    "webp",
                    "svg",
                    "heic",
                    "tiff",
                    "avif",
                    "eps",
                    "ai",
                ];

                if (!allowedExtensions.includes(extension)) {
                    this.$bvToast.toast(
                        "Allowed formats: " + allowedExtensions.join(", "),
                        {
                            title: "Invalid file format.",
                            variant: "danger",
                            solid: true,
                        },
                    );
                    e.target.value = "";
                    return;
                }

                this.owner_sig_name = file.name;
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.owner_sig_preview = event.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        getJsonValue(val) {
            if (!val) return { en: "", bn: "" };
            if (typeof val === "string") {
                try {
                    return JSON.parse(val);
                } catch (e) {
                    return { en: val, bn: "" };
                }
            }
            return val;
        },
        isHeightValid(v) {
            if (!v) return true;
            // Allowed characters: digits, spaces, and height-related words/symbols
            if (!/^([0-9\u09E6-\u09EF\s'\"’‘]|Feet|ft|inch|in|ফুট|ইঞ্চি)+$/i.test(v)) return false;
            // Must contain at least one height signifier (word or symbol) to distinguish from random numbers
            return /['\"’‘]|Feet|ft|inch|in|ফুট|ইঞ্চি/i.test(v);
        },
        downloadWithName(path, name) {
            if (!path) return;
            if (path.startsWith('data:image/')) {
                try {
                    const parts = path.split(';base64,');
                    const contentType = parts[0].split(':')[1];
                    const raw = window.atob(parts[1]);
                    const rawLength = raw.length;
                    const uInt8Array = new Uint8Array(rawLength);
                    for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
                    const blob = new Blob([uInt8Array], { type: contentType });
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = name + '.' + contentType.split('/')[1];
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
                    return;
                } catch (e) {
                    console.error("Base64 download failed, falling back to direct URL", e);
                }
            }
            const url = path.startsWith("http") || path.startsWith("data:") || path.startsWith("blob:") ? path : "/" + path;
            const link = document.createElement("a");
            link.href = url;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

<style scoped>
.label-custom {
    font-size: 0.75rem;
    font-weight: 500;
    margin-bottom: 2px;
    color: #444;
}

.form-control-custom {
    border-radius: 4px;
    border: 1px solid #ced4da;
    /* height: 38px; */
    font-size: 0.85rem;
}

.rounded-left {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.photo-container .no-photo {
    font-size: 0.8rem;
    color: #ccc;
}

::v-deep .custom-file-label {
    font-size: 0.7rem;
}

/* Updated by Jarir 2026-04-20 — Grey out readonly/disabled fields for clear visual distinction */
.form-control-custom[readonly],
.form-control-custom:disabled,
::v-deep .form-control[readonly],
::v-deep .form-control:disabled,
::v-deep .custom-select[readonly],
::v-deep .custom-select:disabled {
    background-color: #e9ecef !important;
    color: #6c757d !important;
    cursor: not-allowed;
    opacity: 1;
}
</style>
